<template>
	<div>
		<input v-model="textToCopy" placeholder="Enter text to copy" v-show="text==''" />
		<button @click="copyToClipboard" class="uk-button uk-button-primary uk-width-1-1 uk-button-small">
			{{ localButtonText }}
		</button>
	</div>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			required: false
		},
		buttonText: {
			type: String,
			default: 'Kopiëer naar clipboard'
		},
		openLink: {
			type: Boolean,
			default: false // Default value for openLink
		},
		link: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			textToCopy: '',
			localButtonText: this.buttonText, // Initialize local data property from prop
		};
	},
	mounted() {
		if (this.text) {
			this.textToCopy = this.text;
		}
	},
	methods: {
		async copyToClipboard() {
			try {
				await navigator.clipboard.writeText(this.textToCopy);
				this.localButtonText = 'URL gekopieerd'; // Modify local data property
				setTimeout(() => {
					this.localButtonText = this.buttonText; // Reset to original prop value after 3 seconds
				}, 3000);

				if (this.openLink && this.link && this.isValidHttpUrl(this.link)) {
					window.open(this.link, '_blank');
				}
			} catch (err) {
				console.log(err);
			}
		},
		isValidHttpUrl(string) {
			let url;
			
			try {
				url = new URL(string);
			} catch (_) {
				return false;  
			}
		
			return url.protocol === "http:" || url.protocol === "https:";
		}
	}
}
</script>
